import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type transactionReportsType = {
  dateFrom: string;
  dateTo: string;
  companyId?: string;
  currency?: string;
  errorCallback: Function;
  resultKey?: string;
};

export default ({
  dateFrom,
  dateTo,
  companyId = '',
  currency = '',
  errorCallback,
  resultKey = 'transactionReportsData',
}: transactionReportsType) =>
  requestAsync({
    url: endpoints.getTransactionReportsUrl(dateFrom, dateTo, companyId, currency),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getTransactionReportsUrl(dateFrom, dateTo, companyId, currency),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
